import type {Builder} from '@wix/document-services-types'
import {SKIP_STYLE_TYPE, STYLE_TYPE_MAP} from '../constants/style'
import {convertDMVariableToCSSValue} from '../dataMappers'
import type {PresetVariableData} from '../types'

export interface IPresetsStylesTransformer {
    transformPresetStyles(presetVariables: Record<string, PresetVariableData>): Builder.StyleOverrides
}

type StyleOverridesValue = Builder.StyleOverrides[string]

export class PresetsStylesTransformer implements IPresetsStylesTransformer {
    transformPresetStyles(presetVariables: Record<string, PresetVariableData>): Builder.StyleOverrides {
        const styleEntries = Object.entries(presetVariables)
            .map(entry => this.processVariableStyle(entry))
            .filter((entry): entry is [string, StyleOverridesValue] => entry !== null)

        return Object.fromEntries(styleEntries)
    }

    private processVariableStyle([variableName, variableData]: [string, PresetVariableData]):
        | [string, StyleOverridesValue]
        | null {
        if (!variableData?.type) {
            return null
        }

        const styleItem = STYLE_TYPE_MAP[variableData.type]
        const skippedStyle = SKIP_STYLE_TYPE[variableData.type]

        if (!styleItem || skippedStyle) {
            return null
        }

        const cssValue = convertDMVariableToCSSValue(styleItem, variableData.value) as string

        if (!cssValue) {
            return null
        }

        return [variableName, {defaultValue: cssValue}]
    }
}
